<template>
  <InvoiceDataTable
    ref="invoiceDataTable"
    :loading="loading"
    :invoices="invoices"
    :invoices-total="invoicesTotalCount"
    :start-default-value="defaultValue.start"
    :end-default-value="defaultValue.end"
    :branch-default-value="defaultValue.branch"
    :is-executor-approved-default-value="defaultValue.isExecutorApproved"
    :is-customer-approved-default-value="defaultValue.isCustomerApproved"
    :is-decline-default-value="defaultValue.isDeclined"
    :search-default-value="defaultValue.search"
    :page-default-value="defaultValue.page"
    :limit-default-value="defaultValue.limit"
    :sort-default-value="defaultValue.sort"
    :desc-default-value="defaultValue.desc"
    :status="defaultValue.status"
    :dialog="dialog"
    :dialog-value="dialogValue"
    :is-statuses-disabled="false"
    @update="onUpdate"
    @print="onPrint"
    @excel-single="onExcelSingleDownload"
    @excel-all="onExcelAllDownload"
    @excel-all-items="onExcelAllDownloadWithItems"
  >
    <template v-slot:title>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Счёт-фактуры</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
    </template>
  </InvoiceDataTable>
</template>

<script>
import InvoiceDataTable from "@/components/DataTables/InvoiceDataTable";
import InvoiceBoxMixin from "./InvoiceBoxMixin";

export default {
  name: "InvoiceAllBoxView",
  mixins: [InvoiceBoxMixin],
  components: {
    InvoiceDataTable,
  },
};
</script>